<template lang="pug">
modal#success-checker-modal(
  :close-button-label='$t("button.ok")'
  :title='$t("modal.successChecker.title")'
)
  .text(v-if='subject') {{ $t('modal.successChecker.subject') }}: {{ subject }}
  .text(v-if='sender') {{ $t('modal.successChecker.sender') }}: {{ sender }}
  .text(v-if='createdAt') {{ $t('modal.successChecker.createdAt') }}: {{ createdAt | dateTime }}
  .text(v-if='status') {{ $t('modal.successChecker.status') }}: {{ $t(status) }}
  .text(v-if='expireAt') {{ $t('modal.successChecker.expireAt') }} {{ expireAt | date }}
  .card.card-activity.shadow.mt-5
    .card-body.recipients-detail
      ul.nav.flex-column
        div
          div(:key='recipient.id' v-for='recipient in recipients')
            div
              li
                small.text {{ recipient.addressees[0].value }}
              li
                IconStatus(:iconStatus='recipient.state')
                small.text {{ $t(recipient.state) }}
            hr
</template>

<script>
import Modal from '@/ui/molecules/Modal.vue';
import IconStatus from '@/ui/atoms/IconStatus.vue';

export default {
  name: 'SuccessCheckerModal',
  props: {
    createdAt: String,
    subject: String,
    status: String,
    sender: String,
    expireAt: String,
    recipients: Array,
  },
  components: {
    Modal,
    IconStatus,
  },
};
</script>
